import { Component, ElementRef, forwardRef } from '@angular/core';
import { MenuSectionComponent } from '../menu-section.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-title-section',
  templateUrl: './title-section.component.html',
  providers: [{ provide: MenuSectionComponent, useExisting: forwardRef(() => TitleSectionComponent) }],
  standalone: false
})
export class TitleSectionComponent extends MenuSectionComponent {
  constructor(
    public sanitizer: DomSanitizer,
    public element: ElementRef
  ) {
    super(sanitizer, element);
  }

  getUniqueIdentifier(): string {
    return this.section?.getUniqueIdentifier();
  }
}
